import { generateButtonClasses } from "./ButtonClasses.js";
import type { LinkProps, LinkVariant } from "./LinkProps.js";

export function generateLinkClasses({
	disabled,
	variant,
	asButton,
	linkVariant,
	noUnderline,
	linkClass,
}: LinkProps): string {
	if (asButton) {
		return generateButtonClasses({ disabled, variant });
	}

	const linkVariants: Record<LinkVariant, string> = {
		primary: "text-ltprimary-300 decoration-ltprimary-300 font-semibold",
		underline: "text-ltprimary-300 decoration-ltprimary-300 font-semibold hover:!underline hover:text-ltprimary-100",
		secondary: "text-ltsecondary decoration-ltsecondary",
		white: "text-white decoration-white",
	};
	const effectiveLinkVariant: LinkVariant = linkVariant ?? (variant === "underline" ? "underline" : "primary");
	const variantClass = linkVariants[effectiveLinkVariant];
	const disabledClass = disabled && "!text-neutral-400 pointer-events-none";

	return [
		"transition-[text-decoration,color] duration-300 cursor-pointer hover:decoration-transparent group flex gap-4 items-center",
		linkClass,
		variantClass,
		noUnderline ? "" : "underline",
		disabledClass,
	]
		.filter(Boolean)
		.join(" ");
}
